import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobTimeDisplayPipe } from './job-time-display.pipe';

@NgModule({
  declarations: [JobTimeDisplayPipe],
  imports: [CommonModule],
  exports: [JobTimeDisplayPipe],
})
export class JobTimeDisplayPipeModule {}
